<template>
  <div class="modal">
    <div class="config">
      <template v-for="feature in visibleFeatures">
        <div
          class="feature"
          :class="{'feature_no-border': feature.type === 'multiple'}"
          :key="feature.question"
        >
          <p class="feature__text g-text" v-html="feature.question"></p>
          <yes-no
            v-if="feature.type === 'boolean'"
            class="feature__select"
            :value="config[feature.identifier] ? 'yes' : 'no'"
            @input="config[feature.identifier] = ($event === 'yes'?1:0)"
          />
          <input
            v-if="feature.type === 'string'"
            :placeholder="feature.placeholder"
            v-model="config[feature.identifier]"
            class="feature__input"
            type="text"
          />
        </div>
        <template v-if="feature.type === 'multiple'">
          <div
            v-for="(option, idx) in feature.choose_from"
            class="feature"
            :class="{'feature_no-border': feature.type === 'multiple'
              && idx !== feature.choose_from.length - 1}"
            :key="option"
          >
            <p class="feature__text g-text" v-html="option"></p>
            <yes-no
              class="feature__select"
              :value="config[feature.identifier].includes(option) ? 'yes' : 'no'"
              @input="onMultipleValueToggle(config[feature.identifier], option)"
            />
          </div>
        </template>
      </template>
    </div>

    <div class="buttons">
      <button class="g-button" @click.prevent="cancel">
        {{ $t("CANCEL") }}
      </button>
      <button class="g-button g-button_primary" @click.prevent="ok">
        {{ $t("INSTALL") }}
      </button>
    </div>
  </div>
</template>

<script>
import YesNo from '@/components/YesNo';

export default {
  props: ['features', 'resolve', 'reject'],
  components: { YesNo },
  data() {
    return {
      config: {},
    };
  },
  computed: {
    visibleFeatures() {
      return this.features.filter(feature => feature.type !== 'multiple' || feature.choose_from?.length > 0);
    },
  },
  methods: {
    getDefaultFeatureValue(feature) {
      if (feature.default) {
        return feature.default;
      }

      if (feature.type === 'boolean') {
        return 0;
      }

      if (feature.type === 'string') {
        return '';
      }

      if (feature.type === 'multiple') {
        return [];
      }

      return undefined;
    },
    onMultipleValueToggle(array, value) {
      const idx = array.indexOf(value);
      if (idx === -1) {
        array.push(value);
        return;
      }

      array.splice(idx, 1);
    },
    cancel() {
      this.$modal.hideAll();
      this.reject();
    },
    ok() {
      this.$modal.hideAll();
      this.resolve(this.config);
    },
  },
  created() {
    this.features.forEach((feature) => {
      this.$set(this.config, feature.identifier, this.getDefaultFeatureValue(feature));
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.vm--overlay {
  background: rgba(0, 0, 0, var(--modal-overlay-opacity));
}

.features-modal {
  background-color: var(--bg);
  border: 2px solid var(--lighter-primary);

  max-width: 600px;
  margin: 0 auto;
}
</style>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.buttons {
  display: flex;
  padding: 10px 15px 15px;
  border-top: 1px solid var(--tertiary-accent);

  button:last-child {
    margin-left: auto;
  }
}

.config {
  padding: 15px 15px 10px;
}

.feature {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }

  &_no-border {
    border-bottom: none;
    padding-bottom: 5px;
  }

  &__info {
    display: block;
    font-size: 12px;
  }

  &__text {
    margin-right: 20px;
  }

  &__select,
  &__file {
    margin-left: auto;
  }

  &__input {
    background: var(--tertiary-bg);
    border: 1px solid var(--tertiary-accent);
    border-radius: 2px;
    padding: 6px;
    margin-left: auto;
    flex: 0 0 150px;
    width: 150px;
    font-size: 14px;
    font-family: "IBM Plex Sans", sans-serif;
    color: var(--text-primary);

    &::placeholder {
      font-family: "IBM Plex Sans", sans-serif;
    }
  }
}

</style>
